import { signIn } from "next-auth/react";
import { useTranslations } from "next-intl";
import { FC, useContext, useState } from "react";

import { useNotification } from "@/components/NotificationProvider/NotificationProvider";
import Button, { ButtonSize, ButtonTheme, ButtonVariant } from "@/components/ui/Button/Button";
import Input from "@/components/ui/Form/Input/Input";
import Icon from "@/components/ui/Icon/Icon";
import { UserContext } from "@/context/UserContext";
import { LoginType } from "@/types";

interface LoginPopupPro {
  closeFunc: (state: boolean) => void;
}

const LoginPopup: FC<LoginPopupPro> = ({ closeFunc }) => {
  const [sendMail, setSendMail] = useState(false);
  // const getFavoritesArray = () => {
  //   let JsonData = JSON.parse(localStorage.getItem("favorites") || "{}") as UnitTypeGroupItem[];
  //   if (JsonData.length == undefined) return [];
  //   return JsonData as UnitTypeGroupItem[];
  // };
  // const [favorites, setFavorites] = useState<UnitTypeGroupItem[]>(getFavoritesArray());
  const { favorites, setSoftLoginModalOpen } = useNotification();

  const handleSendbyMail = () => {
    setSendMail(true);
  };

  const { updateLoginType } = useContext(UserContext);
  const handleSocialLogin = (label: string) => {
    let loginType: LoginType = label.toLowerCase().indexOf("google") >= 0 ? LoginType.GOOGLE_LOGIN : LoginType.APPLE_LOGIN;
    signIn(loginType);
    updateLoginType(loginType);
  };

  const t = useTranslations();

  return (
    <section
      className="fixed z-[100] bg-white  shadow-extra-strong w-full bottom-0 rounded-lg md:bg-gray-10 md:bottom-auto md:right-l md:top-[120px] md:w-[367px] px-m py-l"
      aria-live="polite"
    >
      <button
        className="absolute right-m cursor-pointer"
        onClick={() => {
          closeFunc(false);
        }}
      >
        <Icon size={"24"} name={"close"} className="stroke-black" />
      </button>
      {favorites.length > 1 && (
        <>
          {/* <div className="flex justify-center mt-xs mb-l pt-m">
            <h2 className="w-2/3 uppercase text-center font-primary text-m font-medium leading-4 tracking-widest text-black ">
              {t("label.loginPopUp.save.shortlist")}
            </h2>
          </div>
          <p className="text-center font-secondary text-s font-normal mb-l">{t("label.loginPopUp.message")}</p>

          <Button
            size={ButtonSize.MEDIUM}
            theme={ButtonTheme.BLACK}
            customClass="uppercase w-full mb-l"
            type="button"
            variant={ButtonVariant.PRIMARY}
            onClick={() => {
              closeFunc(false);
              setSoftLoginModalOpen(true);
            }}
          >
            {t("button.loginPopUp.login")}
          </Button> */}

          <div className="relative content-['·'] after:absolute after:top-1/2 after:left-0 after:border-t-[1px]  after:border-gray-20 after:w-1/5 after:md:w-xxl before:absolute before:top-1/2 before:right-0 before:border-t-[1px] before:border-gray-20 before:w-1/5 before:md:w-xxl">
            <h3 className="text-center font-primary font-medium text-m w-14\/24 mx-auto uppercase">{t("label.loginPopUp.through.opt")}</h3>
          </div>
          <div className="pt-l mb-l">
            <Button
              size={ButtonSize.MEDIUM}
              theme={ButtonTheme.BLACK}
              customClass="uppercase w-full"
              type="button"
              variant={ButtonVariant.SECONDARY}
              onClick={() => {
                closeFunc(false);
                setSoftLoginModalOpen(true);
              }}
            >
              {t("button.loginPopUp.opt.sendCode")}
            </Button>
          </div>
          <div className="w-full flex flex-row mt-l">
            <button
              key={"registration-social-"}
              className="w-1/2 flex items-center justify-center cursor-pointer"
              onClick={() => handleSocialLogin("google")}
            >
              <Icon className="stroke-none" name="social-google-color" size="24" title="close" />

              <span className="underline font-secondary font-medium text-s md:pl-xs pl-xxs">{t("label.loginPopUp.continue.google")}</span>
            </button>
            {/* <button
              key={"registration-social-"}
              className="w-1/2 flex items-center justify-center cursor-pointer"
              onClick={() => handleSocialLogin("apple")}
            >
              <Icon className="stroke-black" fill="black" name="social-apple-black" size="24" title="close" />

              <span className="underline font-secondary font-medium text-s md:pl-xs pl-xxs">{t("label.loginPopUp.continue.apple")}</span>
            </button> */}
          </div>
        </>
      )}
      {favorites.length <= 1 && !sendMail && (
        <div>
          <div className="w-21\/24 uppercase text-center font-primary text-s font-medium leading-4 tracking-widest text-black p-xs mb-m pt-m">
            {t("label.loginPopUp.your.progress")}
          </div>
          <div className="text-center font-secondary text-s font-normal mb-m">{t("message.loginPopUp.your.progress")}</div>
          <div className="pt-m mb-l flex flex-row md:flex-col">
            {/* nascondiamolo Diego nel caso */}
            {false && (
              <button
                onClick={handleSendbyMail}
                className="w-1/2 md: pt-l md:w-full order-1 md:order-2 text-s font-secondary font-medium underline flex justify-center items-center cursor-pointer"
              >
                {t("label.loginPopUp.send.by.email")}
              </button>
            )}
            <div className="w-1/2 md:w-full md:order-1 order-2">
              <Button
                size={ButtonSize.MEDIUM}
                theme={ButtonTheme.BLACK}
                customClass="uppercase w-full"
                type="button"
                variant={ButtonVariant.PRIMARY}
                onClick={() => {
                  closeFunc(false);
                  setSoftLoginModalOpen(true);
                }}
              >
                {t("button.loginPopUp.login")}
              </Button>
            </div>
          </div>
        </div>
      )}
      {favorites.length <= 1 && sendMail && (
        <div>
          <div className="w-21\/24 uppercase text-center font-primary text-s font-medium leading-4 tracking-widest text-black p-xs mb-m pt-m">
            {t("label.loginPopUp.send.by.mail")}
          </div>
          <div className="text-center font-secondary text-s font-normal mb-m">{t("message.loginPopUp.receive.shortlist.via.mail")}</div>
          <div className="border-b border-gray-20">
            <Input id="InputID" label="Email" name="InputText" required />
          </div>
          <div className="pt-m mb-xs flex flex-row">
            <div className="w-full">
              <Button size={ButtonSize.MEDIUM} theme={ButtonTheme.BLACK} customClass="uppercase w-full" type="button" variant={ButtonVariant.PRIMARY}>
                {t("button.loginPopUp.send.to.mail")}
              </Button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};
export default LoginPopup;
